import Wrong from '@assets/wrong.svg';
import Bottom from '@assets/bottom.png';
import { Note } from '@components';

import classes from './index.module.css';

const SUBTITLE = 'Something went wrong. \nWe can\'t seem to find the page you\'re looking for.';

export const NotFound = () => (
  <section className={classes.content}>
    <Note
      icon={Wrong}
      title="Oops!"
      subTitle={SUBTITLE}
      hasBackBtn
    />
    <div className={classes.bottom}>
      <img src={Bottom} alt="" className={classes.bottom_img} />
    </div>
  </section>
);
